//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";
